"use client"

import { useEffect, useRef } from "react"
import "./StrengthBusiness.css"

const StrengthBusiness = () => {
  const titleRef = useRef(null)
  const descriptionRef = useRef(null)
  const cardRefs = useRef([])

  const benefits = [
    {
      iconSrc: "/pd1.webp?height=48&width=48", // Replace with your actual icon
      iconAlt: "Project Plan Icon",
      title: "GET A PROJECT PLAN",
      description:
        "Know the detailed steps, needed resources, expected costs and delivery time to build a functional and valuable product.",
    },
    {
      iconSrc: "/pd2.webp?height=48&width=48", // Replace with your actual icon
      iconAlt: "User Experience Icon",
      title: "CREATE AN ENGAGING USER EXPERIENCE",
      description:
        "Follow the necessary steps (from research and ideation to development) to ensure a well-grounded UX.",
    },
    {
      iconSrc: "/pd3.webp?height=48&width=48", // Replace with your actual icon
      iconAlt: "Time and Costs Icon",
      title: "REDUCE TIME AND COSTS",
      description: "The high-level PDP design allows you to plan realistic schedules and avoid redesigning costs.",
    },
    {
      iconSrc: "/pd4.webp?height=48&width=48", // Replace with your actual icon
      iconAlt: "Profitability Icon",
      title: "INCREASE PROFITABILITY",
      description: "Grow revenue and business value with a well-thought-out UX that increases conversions.",
    },
  ]

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.1 },
    )

    // Observe title and description
    if (titleRef.current) observer.observe(titleRef.current)
    if (descriptionRef.current) observer.observe(descriptionRef.current)

    // Observe each card
    cardRefs.current.forEach((card) => {
      if (card) observer.observe(card)
    })

    return () => {
      if (titleRef.current) observer.unobserve(titleRef.current)
      if (descriptionRef.current) observer.unobserve(descriptionRef.current)
      cardRefs.current.forEach((card) => {
        if (card) observer.unobserve(card)
      })
    }
  }, [])

  return (
    <div className="strength-business-container" id="benefits">
      <div className="container">
      <div className="strength-business-wrapper">
        {/* Header Section */}
        <div className="strength-business-header">
          <div className="strength-business-title-wrapper animate-left" ref={titleRef}>
            <h2 className="strength-business-title">
              STRENGTHEN YOUR
              <br />
              BUSINESS WITH OUR
              <br />
              <span className="strength-business-highlight">PRODUCT DESIGN</span>
              <br />
              <span className="strength-business-highlight">PROCESS</span>
            </h2>
          </div>
          <div className="strength-business-description-wrapper animate-left" ref={descriptionRef}>
            <p className="strength-business-description">
              Follow our unmatched Product Design Process to build meaningful and user-driven interfaces. It selects a
              collection of matured techniques and tools capable of skyrocketing your online product's usability,
              efficiency and success.
            </p>
          </div>
        </div>

        {/* Benefits Grid */}
        <div className="strength-business-grid">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="strength-business-card animate-up"
              ref={(el) => (cardRefs.current[index] = el)}
              style={{ "--animation-delay": `${index * 0.1}s` }}
            >
              <div className="strength-business-icon">
                <img
                  src={benefit.iconSrc || "/placeholder.svg"}
                  alt={benefit.iconAlt}
                  className="strength-icon-image"
                />
              </div>
              <h3 className="strength-business-card-title">{benefit.title}</h3>
              <p className="strength-business-card-description">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
      </div>
    </div>
  )
}

export default StrengthBusiness
